import { CLEAN_AIRLINES_FILTER, SET_SEARCH_FILTER } from "../shared/constants";
import { flightsSum } from "../shared/utils";

export const initialFiltersState = {
	inbound: {
		airlines: [],
		destinationAirports: [],
		originAirports: [],
		stops: [],
		departureTimes: [],
		feeTypes: []
	},
	outbound: {
		airlines: [],
		destinationAirports: [],
		originAirports: [],
		stops: [],
		departureTimes: [],
		feeTypes: []
	}
};

export const selectedFilters = (state = initialFiltersState, action) => {
	switch (action.type) {
		case SET_SEARCH_FILTER:
			const filterAttribute = Object.keys(action.filter)[0];
			const filterValue = action.filter[filterAttribute];

			let storedAttribute = state[action.stretch][filterAttribute];
			let actionValueIndex = storedAttribute.indexOf(filterValue);

			if (actionValueIndex > -1)
				storedAttribute = storedAttribute.filter(elm => elm !== filterValue);
			else storedAttribute = storedAttribute.concat(filterValue);

			return {
				...state,
				[action.stretch]: {
					...state[action.stretch],
					[filterAttribute]: storedAttribute
				}
			};

		case CLEAN_AIRLINES_FILTER:
			return {
				...state,
				outbound: {
					...state["outbound"],
					airlines: []
				},
				inbound: {
					...state["inbound"],
					airlines: []
				}
			};

		default:
			return state;
	}
};
